import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { useTranslation } from 'react-i18next';
import logoutUser from 'utils/auth/logout';
import { redirectToLogin } from 'utils/auth/getLogoutPath';
import useCustomContactLink from 'hooks/useCustomContactLink';
import Pill from 'components/Pill';
import VisuallyHidden from 'components/VisuallyHidden';
import { NavMenu, NavMenuList, NavMenuItem, NavMenuButton, NavMenuDivider, NavMenuItemGroup } from 'components/NavMenu';
import { useFetchUserProfile } from 'actions/userProfile';
import { setAlert } from 'actions/alerts';
import { useAuthContext } from '../../../contexts/auth';
import AddToHomeScreenLink from './AddToHomescreen';
import { NavMenuRouterLinkItem } from './NavMenuRouterLinkItem';
import { AdminAndManagerLinks } from './AdminAndManagerLinks';
import CustomUserMenuLinks from './CustomUserMenuLinks';
import getUserDisplayName from './getUserDisplayName';
import { useUnreadCount } from './useUnreadCount';
function UserMenu() {
  var _useAuthContext = useAuthContext(),
    setAuthUser = _useAuthContext.setAuthUser;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var _useFetchUserProfile = useFetchUserProfile(),
    userProfile = _useFetchUserProfile.data;
  var contactLink = useCustomContactLink();
  var unreadCount = useUnreadCount();
  function logout(_x) {
    return _logout.apply(this, arguments);
  }
  function _logout() {
    _logout = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(e) {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            _context.prev = 1;
            _context.next = 4;
            return logoutUser();
          case 4:
            setAuthUser(null);
            redirectToLogin();
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            setAlert({
              title: t('alert_logout_failed'),
              message: _context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.error
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[1, 8]]);
    }));
    return _logout.apply(this, arguments);
  }
  var userSectionHeading = getUserDisplayName(userProfile) || t('property_settings');
  var hasUnreadNotifications = unreadCount > 0;
  return /*#__PURE__*/React.createElement(NavMenu, {
    menuPositionFixed: true,
    menuPlacement: "bottom-end"
  }, /*#__PURE__*/React.createElement(NavMenuButton, {
    iconOnly: true,
    icon: "tools",
    variant: "transparent"
  }, /*#__PURE__*/React.createElement(VisuallyHidden, null, t('actions_toggle_nav'))), /*#__PURE__*/React.createElement(NavMenuList, null, /*#__PURE__*/React.createElement(NavMenuItemGroup, {
    label: userSectionHeading
  }, /*#__PURE__*/React.createElement(NavMenuRouterLinkItem, {
    to: "/settings"
  }, t('navbar_user_settings')), /*#__PURE__*/React.createElement(NavMenuRouterLinkItem, {
    to: "/inbox",
    id: "inbox",
    text: t('navbar_inbox')
  }, t('navbar_inbox'), hasUnreadNotifications && /*#__PURE__*/React.createElement(Pill, {
    role: "alert",
    ml: "xxs",
    "aria-label": t('unread_messages', {
      count: unreadCount
    }),
    background: "highlight"
  }, unreadCount)), contactLink.url ? /*#__PURE__*/React.createElement(NavMenuItem, {
    as: "a",
    href: contactLink.url,
    target: "_blank"
  }, contactLink.title) : /*#__PURE__*/React.createElement(NavMenuItem, {
    as: "button",
    onClick: contactLink.openModal
  }, contactLink.title)), /*#__PURE__*/React.createElement(CustomUserMenuLinks, null), /*#__PURE__*/React.createElement(AddToHomeScreenLink, null), /*#__PURE__*/React.createElement(AdminAndManagerLinks, null), /*#__PURE__*/React.createElement(NavMenuDivider, null), /*#__PURE__*/React.createElement(NavMenuItem, {
    id: "log_out_button",
    onClick: logout
  }, t('actions_logout'))));
}
export default UserMenu;